import Filter from './../Filter.js'
import Product from './../Product.js'
import Configure from './../Configure.js'
import Packages from './../Packages.js'
import Food from './../Food.js'
import Accordion from './../Accordion.js'
import More from './../More.js'

$(function () {
    const moduleFilter = new Filter()
    moduleFilter.init()

    const moduleProduct = new Product()
    moduleProduct.init()

    const modulePackages = new Packages()
    modulePackages.init()

    const moduleFood = new Food()
    moduleFood.init()

    const moduleAccordion = new Accordion()
    moduleAccordion.init()

    const moduleMore = new More()
    moduleMore.init()

    const moduleConfigure = new Configure()
    moduleConfigure.init()
})
